import axios from "axios";
import { errorHandler } from "@/Services/errorHandler";
import queryStringify from "qs-stringify";

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getTurnOverData(context) {
      let payload = {
        ...context.getters.getTimeFrame,
      };
      let stores = JSON.parse(localStorage.getItem("stores"));
      let store = JSON.parse(localStorage.getItem("selected_store"));

      if (!stores || stores.length === 0) return;
      let group = stores[0].Group;
      let storeDB = store.StoreDB;

      let headers = {
        DB: storeDB ? window.btoa(storeDB) : null,
        group: window.btoa(group),
      };

      const queryString = `?` + queryStringify(payload);
      try {
        const { data } = await axios.get(
          reportsApi + `completedsales/get-turnover` + queryString,
          { headers }
        );
        return data;
      } catch (err) {
        errorHandler.tomcatError(err);
      }
    },
    async getCompletedSalesDetails(context) {
      const payload = {
        ...context.getters.getTimeFrame,
      };
      const stores = JSON.parse(localStorage.getItem("stores") || "[]");
      const store = JSON.parse(localStorage.getItem("selected_store") || "null");

      if (!stores || stores.length === 0) return [];
      const group = stores[0].Group;
      const storeDB = store ? store.StoreDB : null;

      const headers = {
        DB: storeDB ? window.btoa(storeDB) : null,
        group: window.btoa(group),
      };

      const queryString = `?` + queryStringify(payload);
      try {
        const { data } = await axios.get(
          reportsApi + `completedsales/by-group` + queryString,
          { headers }
        );
        if (Array.isArray(data)) return data;
        if (data && Array.isArray(data.rows)) return data.rows;
        return [];
      } catch (err) {
        errorHandler.tomcatError(err);
        return [];
      }
    },
    async getOnlineVsOfflineInvoices(context, { type = "online", limit = 100 } = {}) {
      const payload = {
        ...context.getters.getTimeFrame,
        type,
        limit,
      };
      const stores = JSON.parse(localStorage.getItem("stores") || "[]");
      const store = JSON.parse(localStorage.getItem("selected_store") || "null");

      if (!stores || stores.length === 0) return [];
      const group = stores[0].Group;
      const storeDB = store ? store.StoreDB : null;

      const headers = {
        DB: storeDB ? window.btoa(storeDB) : null,
        group: window.btoa(group),
      };

      const queryString = `?` + queryStringify(payload);
      try {
        const { data } = await axios.get(
          reportsApi + `sales/online-offline-invoices` + queryString,
          { headers }
        );
        return Array.isArray(data) ? data : [];
      } catch (err) {
        errorHandler.tomcatError(err);
        return [];
      }
    },
    async getOnlineVsOfflineSales(context) {
      const payload = {
        ...context.getters.getTimeFrame,
      };
      const stores = JSON.parse(localStorage.getItem("stores") || "[]");
      const store = JSON.parse(localStorage.getItem("selected_store") || "null");

      if (!stores || stores.length === 0) return [];
      const group = stores[0].Group;
      const storeDB = store ? store.StoreDB : null;

      const headers = {
        DB: storeDB ? window.btoa(storeDB) : null,
        group: window.btoa(group),
      };

      const queryString = `?` + queryStringify(payload);
      try {
        const { data } = await axios.get(
          reportsApi + `sales/online-offline-split` + queryString,
          { headers }
        );
        if (Array.isArray(data)) return data;
        return [];
      } catch (err) {
        errorHandler.tomcatError(err);
        return [];
      }
    },
    async getFranchiseRevenue(context) {
      let payload = {
        ...context.getters.getTimeFrame,
      };
      let stores = JSON.parse(localStorage.getItem("stores"));
      let store = JSON.parse(localStorage.getItem("selected_store"));

      if (!stores || stores.length === 0) return;
      let group = stores[0].Group;
      let storeDB = store.StoreDB;

      let headers = {
        DB: storeDB ? window.btoa(storeDB) : null,
        group: window.btoa(group),
      };

      const queryString = `?` + queryStringify(payload);
      try {
        const { data } = await axios.get(
          reportsApi + `businessOverview/revenue` + queryString,
          { headers }
        );

        return data;
      } catch (err) {
        errorHandler.tomcatError(err);
      }
    },
    async getNegativePosition(context) {
      let payload = {
        ...context.getters.getTimeFrame,
      };
      let stores = JSON.parse(localStorage.getItem("stores"));
      let store = JSON.parse(localStorage.getItem("selected_store"));

      if (!stores || stores.length === 0) return;
      let group = stores[0].Group;
      let storeDB = store.StoreDB;

      let headers = {
        DB: storeDB ? window.btoa(storeDB) : null,
        group: window.btoa(group),
      };

      const queryString = `?` + queryStringify(payload);
      try {
        const { data } = await axios.get(
          reportsApi + `businessOverview/negativePositive` + queryString,
          { headers }
        );
        return data;
      } catch (err) {
        errorHandler.tomcatError(err);
      }
    },
    async getPositivePosition(context) {
      let payload = {
        ...context.getters.getTimeFrame,
      };
      let stores = JSON.parse(localStorage.getItem("stores"));
      let store = JSON.parse(localStorage.getItem("selected_store"));

      if (!stores || stores.length === 0) return;
      let group = stores[0].Group;
      let storeDB = store.StoreDB;

      let headers = {
        DB: storeDB ? window.btoa(storeDB) : null,
        group: window.btoa(group),
      };

      const queryString = `?` + queryStringify(payload);
      try {
        const { data } = await axios.get(
          reportsApi + `businessOverview/positivePosition` + queryString,
          { headers }
        );
        return data;
      } catch (err) {
        errorHandler.tomcatError(err);
      }
    },

    // Printing functions
    async printFranchiseTurnoverPDF(context) {
      let payload = {
        ...context.getters.getTimeFrame,
      };
      let stores = JSON.parse(localStorage.getItem("stores"));
      if (!stores || stores.length === 0) return;
      let group = stores[0].Group;

      const queryString = `?` + queryStringify(payload);
      let headers = {
        group: window.btoa(group),
      };

      try {
        const response = await axios.get(
          docsApi + `stocks/export/pdf/franchiseTurnovers` + queryString,
          {
            headers,
            responseType: `blob`,
          }
        );
        openFile(response, `Franchise TurnOver PDF`);
      } catch (err) {
        errorHandler.tomcatError(err);
      }
    },

    async printFranchiseTurnoverCSV(context) {
      let payload = {
        ...context.getters.getTimeFrame,
      };
      let stores = JSON.parse(localStorage.getItem("stores"));
      if (!stores || stores.length === 0) return;
      let group = stores[0].Group;

      const queryString = `?` + queryStringify(payload);
      let headers = {
        group: window.btoa(group),
      };

      try {
        const response = await axios.get(
          docsApi + `stocks/export/excel/franchiseTurnovers` + queryString,
          {
            headers,
            responseType: `blob`,
          }
        );
        openFile(response, `Franchise TurnOver CSV`);
      } catch (err) {
        errorHandler.tomcatError(err);
      }
    },
  },
};
